<template>
  <div id="app" @click="closeAll"   @mousemove="resetTimer" @keypress="resetTimer">
<!--    <transition name="fade" mode="out-in">-->
<!--      <router-view></router-view>-->
      <router-view style="width: 100%;height: 100%"/>
<!--    </transition>-->
<!--    <router-view></router-view>-->
    <div class="warning_voice">
      <audio id="audioMusic" class="audio" src="../src/assets/mp3/interface.mp3" preload="auto" controls :hidden="true" ref="audioMusic"></audio>
      <audio id="newTask" class="audio" src="../src/assets/mp3/newTask.mp3" preload="auto" controls :hidden="true" ref="newTask"></audio>
    </div>

    <!-- 多段账号权限改变提示dialog -->
    <el-dialog :close-on-click-modal="false" title="" :visible.sync="dialogVisible" width="30%" top="35vh">
      <div style="margin-top: 24px">The permission under this account has been updated. Please re-login.</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onlickLogout">OK</el-button>
      </span>
    </el-dialog>



  </div>
</template>

<script>
import EventBus from './ws/eventBus'
import store from "@/store/index";
import router from "@/router/router";
export default {
  name: 'App',
  data(){
    return{
      inactivityTimer: null,
      inactivityTime:  3*60 * 1000, // 5分钟，可以根据需要调整
      audioUnlocked: false,
      unlockListenersArmed: false,
    }
  },
  created() {
    //消息通知提示音
    EventBus.$on('updateRemindRing',()=>{
      this.playRemindSound()
    })
    //新任务提示音：不用 audio.click()（会误关 click 触发的 popover）；单元素强制重播
    EventBus.$on('newTaskCome',()=>{
      this.playNewTaskSound()
    })
  },
  mounted() {
    let login_type =JSON.parse(localStorage.getItem('userInfo')).type
    if (login_type == 0 || login_type){
      this.$WebSocket.startWs()
    }

    // 真实用户手势解锁自动播放（pointerdown / keydown）
    this.armUnlockListeners()
    document.addEventListener('visibilitychange', this.onVisibilityChange)

    this.resetTimer()
    window.addEventListener('scroll', this.resetTimer)
  },
  methods:{
    armUnlockListeners() {
      if (this.unlockListenersArmed) return
      document.addEventListener('pointerdown', this.unlockAudio, true)
      document.addEventListener('keydown', this.unlockAudio, true)
      this.unlockListenersArmed = true
    },
    disarmUnlockListeners() {
      if (!this.unlockListenersArmed) return
      document.removeEventListener('pointerdown', this.unlockAudio, true)
      document.removeEventListener('keydown', this.unlockAudio, true)
      this.unlockListenersArmed = false
    },
    // 自动播放被策略拒绝后，允许下一次真实手势重新解锁
    onPlayBlocked(err) {
      if (!err || err.name !== 'NotAllowedError') return
      this.audioUnlocked = false
      this.armUnlockListeners()
    },
    onVisibilityChange() {
      if (document.visibilityState !== 'visible') return
      // 回到前台：若许可可能已失效，确保手势监听可用（不强制播，避免误响）
      if (!this.audioUnlocked) {
        this.armUnlockListeners()
      }
    },
    unlockAudio() {
      if (this.audioUnlocked) return Promise.resolve()
      const audios = [
        this.$refs.newTask || document.getElementById('newTask'),
        this.$refs.audioMusic || document.getElementById('audioMusic'),
      ].filter(Boolean)

      const unlockOne = (audio) => {
        const wasMuted = audio.muted
        audio.muted = true
        const p = audio.play()
        if (!p || typeof p.then !== 'function') {
          audio.muted = wasMuted
          return Promise.resolve()
        }
        return p.then(() => {
          audio.pause()
          audio.currentTime = 0
          audio.muted = wasMuted
        }).catch((err) => {
          audio.muted = wasMuted
          throw err
        })
      }

      return Promise.all(audios.map(unlockOne)).then(() => {
        this.audioUnlocked = true
        this.disarmUnlockListeners()
      }).catch(() => {
        // 手势未满足策略时保留监听，等待下一次真实交互
        this.armUnlockListeners()
      })
    },
    playMedia(audio) {
      if (!audio) return
      try {
        audio.currentTime = 0
      } catch (e) {}
      const p = audio.play()
      if (p && typeof p.then === 'function') {
        p.catch((err) => {
          this.onPlayBlocked(err)
        })
      }
    },
    playRemindSound() {
      const audio = this.$refs.audioMusic || document.getElementById('audioMusic')
      this.playMedia(audio)
    },
    playNewTaskSound() {
      const audio = this.$refs.newTask || document.getElementById('newTask')
      // 单元素强制重播：不因 paused=false 跳过（避免卡死后永久无声）
      this.playMedia(audio)
    },
    resetTimer() {
      clearTimeout(this.inactivityTimer)
      this.inactivityTimer = setTimeout(this.refreshPage, this.inactivityTime)
    },
    refreshPage() {
      if (this.$route.path == '/Dispatch') {
        window.location.reload()
      }
    },


    closeAll(){
      // EventBus.$emit('closeAll')
    },
    onlickLogout(){
      store.commit("changeGlobalDialogStatus",false);
      // localStorage.removeItem("token");
      // this.logout();
    },
    logout() {
      router.push("/login");
    },
  },
  destroyed() {
    EventBus.$off('updateRemindRing')
    EventBus.$off('newTaskCome')
  },
  beforeDestroy() {
    clearTimeout(this.inactivityTimer)
    window.removeEventListener('scroll', this.resetTimer)
    document.removeEventListener('visibilitychange', this.onVisibilityChange)
    this.disarmUnlockListeners()
  },
  computed: {
    dialogVisible() {
      return store.state.globalDialogTag;
    },
  }
}
</script>

<style>
#app {
  /*font-family: Avenir, Helvetica, Arial, sans-serif;*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 100vh;
}
</style>

<style scoped lang="less">
    // /deep/
    .el-dialog__wrapper {
        background-color: #8F96A0;
    }
</style>
